module.exports = __webpack_public_path__ + "static/media/image_part_012.cc69bc7b.jpg";